import React, { useState } from 'react';
import {
  Badge,
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Button,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Input,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';

import { useCreateUserInvitationMutation, useResendUserInvitationMutation } from '../../Redux/features/auth/authApiSlice';

export default function InvitesForm({ brandData, usersData, userInvitations }) {

  const [createUserInvitation, { isLoading: isLoadingCreateUserInvitation }] = useCreateUserInvitationMutation();
  const [resendUserInvitation] = useResendUserInvitationMutation();
  const [resendingId, setResendingId] = useState(null);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [emailInput, setEmailInput] = useState('');
  const toast = useToast();

  const handleSendInvite = async () => {
    // Aquí deberías hacer tu llamada real al backend
    console.log('Enviando invitación a:', emailInput);

    const invitationEmails = {
      "emails": [emailInput]
    }

    try {
      await createUserInvitation(invitationEmails).unwrap();
      toast({
        title: 'Invitación enviada',
        description: `Se ha enviado una invitación a ${emailInput}`,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      setEmailInput('');
      onClose();
    } catch (error) {
      console.log(error);
      toast({
        title: 'Hubo un error al enviar la invitación',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleResendInvite = async (invitationId) => {
    setResendingId(invitationId);

    try {
      await resendUserInvitation(invitationId).unwrap();
      toast({
        title: 'Invitación enviada de nuevo',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
    } catch (error) {
      console.log(error);
      toast({
        title: 'Hubo un error al reenviar la invitación',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setResendingId(null);
    }
  };


  return (
    <Box maxW="900px">
      <Text fontSize="lg" fontWeight="bold" mb={4}>Usuarios actuales</Text>
      <Table variant="simple" size="md" mb={8}>
        <Thead>
          <Tr>
            <Th>Nombre</Th>
            <Th>Email</Th>
            <Th>Rol</Th>
            <Th>Estado</Th>
          </Tr>
        </Thead>
        <Tbody>
          {usersData?.map(user => (
            <Tr key={user.id}>
              <Td>{user.firstName || '—'}</Td>
              <Td>{user.email}</Td>
              <Td><Badge colorScheme='green'>Usuario</Badge></Td>
              <Td>Activo</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <Flex justify="space-between" align="center" mb={4}>
        <Text fontSize="lg" fontWeight="bold">Invitaciones enviadas</Text>
        <Button
          onClick={onOpen}
          color="white"
          bg="black"
          _hover={{ bg: 'black', color: 'white' }}
          size="sm"
          mr={5}
        >
          Invitar
        </Button>
      </Flex>

      {userInvitations?.length > 0 ? (
        <Table variant="simple" size="md">
          <Thead>
            <Tr>
              <Th>Email</Th>
              <Th textAlign="right">Acciones</Th>
            </Tr>
          </Thead>
          <Tbody>
            {userInvitations.map(invite => (
              <Tr key={invite.id}>
                <Td>{invite.email}</Td>
                <Td textAlign="right">
                  <Button
                    isLoading={resendingId === invite.id}
                    size="sm"
                    onClick={() => handleResendInvite(invite.id)}
                  >
                    Reenviar email
                  </Button>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      ) : (
        <Box p={6} borderWidth={1} borderRadius="md" borderColor="gray.200" textAlign="center">
          <Text mb={2}>Aún no has enviado ninguna invitación.</Text>
          <Button
            onClick={onOpen}
            color="white"
            bg="black"
            _hover={{ bg: 'black', color: 'white' }}
            size="sm"
          >
            Invitar
          </Button>
        </Box>
      )}

      {/* Modal de invitación */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Invita a un miembro de tu equipo</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Input
              placeholder="Correo electrónico"
              type="email"
              value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)}
            />
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Cancelar
            </Button>
            <Button color="white"
              isLoading={isLoadingCreateUserInvitation}
              loadingText="Enviando..."
              bg="black"
              _hover={{ bg: 'black', color: 'white' }} onClick={handleSendInvite} isDisabled={!emailInput}>
              Enviar invitación
            </Button>

          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}
